"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultWidth = exports.defaultIconSize = exports.defaultTabIndex = exports.classes = void 0;
var classes = {
  iconWrapper: 'icon-wrapper'
};
exports.classes = classes;
var defaultTabIndex = '0';
exports.defaultTabIndex = defaultTabIndex;
var defaultIconSize = 24;
exports.defaultIconSize = defaultIconSize;
var defaultWidth = '300px';
exports.defaultWidth = defaultWidth;